import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { PatientProfileProvider } from '../../../../hooks/use-patient-profile';
import { PatientProfilePageProvider } from './hooks';
import { PatientProfileRoutePath } from './navigation/route-config';
import { PatientProfilePageComponent } from './patient-profile-page';

interface RouteParams {
  id: string;
}

const PatientProfilePageWithProvider = () => {
  const { id } = useParams<RouteParams>();
  const [view, setView] = useState<PatientProfileRoutePath>();

  if (!id) return null;

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const viewParam = queryParams.get('view');
    const enumView = ('/' + viewParam) as PatientProfileRoutePath;

    if (viewParam && Object.values(PatientProfileRoutePath).includes(enumView)) {
      setView(enumView);
    }
  }, [location]);

  return (
    <PatientProfileProvider>
      <PatientProfilePageProvider id={parseInt(id)} view={view}>
        <PatientProfilePageComponent />
      </PatientProfilePageProvider>
    </PatientProfileProvider>
  );
};

export const PatientProfilePage = PatientProfilePageWithProvider;
